<div class="users-page">

  <p-toast position="top-right" />
  <p-confirmDialog />

  <!-- En-tête ─────────────────────────────────────────────────────────────── -->
  <div class="page-top">
    <div>
      <h1 class="page-title">Gestion des utilisateurs</h1>
      <p class="page-subtitle">Comptes particuliers, professionnels et administrateurs de la plateforme</p>
    </div>
    <div class="page-top-actions">
      @if (!loading()) {
        <span class="kpi-chip">
          <i class="pi pi-users"></i>
          {{ page().totalElements }} utilisateur{{ page().totalElements > 1 ? 's' : '' }}
        </span>
      }
      @if (authService.hasPermission('USERS_CREATE')) {
        <button pButton icon="pi pi-plus" label="Nouvel utilisateur" class="btn-new" (click)="openCreateDialog()"></button>
      }
      @if (authService.isSuperAdmin() || authService.hasPermission('SYSTEM_USERS_MANAGE')) {
        <button pButton [outlined]="true" icon="pi pi-shield" label="Nouveau compte système" class="btn-new-system" (click)="openSystemCreateDialog()"></button>
      }
    </div>
  </div>

  <!-- Filtres ──────────────────────────────────────────────────────────────── -->
  <div class="filters-bar">
    <span class="search-wrap">
      <i class="pi pi-search search-icon"></i>
      <input pInputText class="search-input"
             [ngModel]="searchTerm()" (ngModelChange)="onSearchChange($event)"
             placeholder="Rechercher par nom, email, téléphone…">
    </span>
    <p-select class="role-select" [options]="roleOptions" optionLabel="label" optionValue="value"
              [ngModel]="roleFilter()" (ngModelChange)="onRoleFilterChange($event)"
              placeholder="Filtrer par rôle"></p-select>
  </div>

  <!-- Table ────────────────────────────────────────────────────────────────── -->
  <div class="table-wrap">
    <p-table [value]="page().content" [lazy]="true" (onLazyLoad)="onLazyLoad($event)"
             [paginator]="true" [rows]="20" [totalRecords]="page().totalElements"
             [rowsPerPageOptions]="[10,20,50]" [loading]="loading()" [rowHover]="true"
             paginatorDropdownAppendTo="body"
             styleClass="users-table" [showCurrentPageReport]="true"
             currentPageReportTemplate="{first} - {last} sur {totalRecords}">
      <ng-template #header>
        <tr>
          <th>Utilisateur</th>
          <th>Téléphone</th>
          <th>Rôle</th>
          <th>Type</th>
          <th>Statut</th>
          <th>Créé le</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template #body let-u>
        <tr>
          <td class="cell-main">
            <div class="user-name">{{ u.firstName }} {{ u.lastName }}</div>
            <div class="user-email">{{ u.email }}</div>
            @if (u.accountType === 'PROFESSIONNEL' && u.companyName) {
              <div class="user-company"><i class="pi pi-building"></i>{{ u.companyName }}</div>
            }
          </td>
          <td class="cell-phone">{{ u.phone || '—' }}</td>
          <td><app-status-tag [label]="roleLabel(u.role)" [severity]="roleSeverity(u.role)" /></td>
          <td><span class="chip-type">{{ accountTypeLabel(u.accountType) }}</span></td>
          <td><app-status-tag [label]="statusLabel(u)" [severity]="statusSeverity(u)" /></td>
          <td class="cell-date">{{ formatDate(u.createdAt) }}</td>
          <td class="cell-action">
            @if (authService.isSuperAdmin() && u.accountType === 'SYSTEM') {
              <button pButton [outlined]="true" class="btn-permissions"
                      severity="secondary"
                      (click)="openPermissionsDialog(u)"
                      icon="pi pi-key"
                      pTooltip="Gérer les permissions"></button>
            }
            @if (authService.hasPermission('USERS_LOCK')) {
              <button pButton [outlined]="true" class="btn-toggle-lock"
                      [severity]="u.locked ? 'success' : 'danger'"
                      [disabled]="toggling() === u.id" [loading]="toggling() === u.id"
                      (click)="confirmToggleLock(u, $event)"
                      [icon]="u.locked ? 'pi pi-lock-open' : 'pi pi-lock'"
                      [pTooltip]="u.locked ? 'Déverrouiller ce compte' : 'Verrouiller ce compte'"
                      [label]="u.locked ? 'Déverrouiller' : 'Verrouiller'"></button>
            }
          </td>
        </tr>
      </ng-template>
      <ng-template #emptymessage>
        <tr>
          <td colspan="7">
            <app-empty-state icon="pi-users" title="Aucun utilisateur trouvé"
                              message="Modifiez vos critères de recherche ou créez un nouvel utilisateur." />
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <!-- Dialogue de création ─────────────────────────────────────────────────── -->
  <app-user-form [(visible)]="createDialogVisible" (created)="onUserCreated($event)" />
  <app-system-user-form [(visible)]="systemCreateDialogVisible" (created)="onUserCreated($event)" />

  <!-- Dialogue de permissions ──────────────────────────────────────────────── -->
  <app-user-permissions [(visible)]="permissionsDialogVisible" [user]="permissionsUser()" />

</div>
